// extracted by mini-css-extract-plugin
export default {"wrapper":"EditHolidayMembersForm_wrapper__QJpAa","membersWrapper":"EditHolidayMembersForm_membersWrapper__SlMcx","submitWrapper":"EditHolidayMembersForm_submitWrapper__nxyUS"};